import * as React from 'react'

function SvgUy(props) {
	return (
		<svg viewBox="-5 -5 27 18" width="1em" height="1em" {...props}>
			<path fill="#fff" d="M-5-5h27v18H-5z" />
			<g fill="#0038a8">
				<path d="M5-3h17v2H5zM5 1h17v2H5zM-5 5h27v2H-5zM-5 9h27v2H-5z" />
			</g>
			<g
				transform="scale(.11)"
				fill="#fcd116"
				stroke="#000"
				strokeWidth={0.6}
				strokeMiterlimit={20}
			>
				<g id="uy_svg__c">
					<g id="uy_svg__b">
						<g id="uy_svg__a">
							<path
								d="M1.5 9L6 12c-8 13 1 15-6 21 3-7-3-5-3-17"
								strokeLinecap="square"
								transform="rotate(22.5)"
							/>
							<path d="M0 11c-2 13 4.5 17 0 22" fill="none" transform="rotate(22.5)" />
							<path d="M0 0h6L0 33-6 0h6v33" />
						</g>
						<use xlinkHref="#uy_svg__a" transform="rotate(45)" />
					</g>
					<use xlinkHref="#uy_svg__b" transform="rotate(90)" />
				</g>
				<use xlinkHref="#uy_svg__c" transform="rotate(180)" />
				<circle r={11} />
			</g>
			<g transform="scale(.011)">
				<g id="uy_svg__d">
					<path d="M81-44c-7 8-11-6-36-6S16-35 12-38s21-21 29-22 31 7 40 16m-29 9c7 6 1 19-6 19S26-28 32-36" />
					<path d="M19-26c1-12 11-14 27-14s23 12 29 15c-7 0-13-10-29-10s-16 0-27 10m3 2c4-6 9 6 20 6s17-3 24-8-10 12-21 12-26-6-23-10" />
					<path d="M56-17c13-7 5-17 0-19 2 2 10 12 0 19M0 43c6 0 8-2 16-2s27 11 38 7c-23 9-14 3-54 3h-5m63 6c-4-7-3-5-11-16 8 6 10 9 11 16M0 67c25 0 21-5 54-19-24 3-29 11-54 11h-5m5-29c7 0 9-5 17-5s19 3 24 7c1 1-3-8-11-9S25 9 16 7c0 4 3 3 4 9 0 5-9 5-11 0 2 8-4 8-9 8" />
				</g>
				<use xlinkHref="#uy_svg__d" transform="scale(-1 1)" />
				<path d="M0 76c-5 0-18 3 0 3s5-3 0-3" />
			</g>
		</svg>
	)
}

export default SvgUy
